var _templateObject = _taggedTemplateLiteralLoose(['background-color: ', '; color: #FFFFFF'], ['background-color: ', '; color: #FFFFFF']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
import { css } from 'emotion';

import { RXBlock, RXBlockStatus, RXBlockColor, RXModal, RXModalSize, RXModalColor } from '@radixnpm/rx-core';
import { RXForm } from './RXForm';

var logdown = require('logdown');
var console = logdown('rx-forms-rx-modal-form', { prefixColor: '#ef6c00' });

export var RXModalForm = function (_Component) {
    _inherits(RXModalForm, _Component);

    function RXModalForm(props) {
        _classCallCheck(this, RXModalForm);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.show = function () {
            console.log('try without waitLoad');
            _this.setState({ show: true });
        };

        _this.onLoad = function () {
            console.log('in onOpenedModal');
            if (_this.state.waitLoad) {
                console.log('try to show with waitLoad');
                _this.setState({ blockStatus: RXBlockStatus.LOAD, buttonDisabled: true });
                new Promise(function (success, fail) {
                    _this.props.onLoad(success, fail);
                }).then(function (data) {
                    _this.setState({ blockStatus: RXBlockStatus.SUCCESS, buttonDisabled: false });
                }).catch(function (error) {
                    _this.setState({ blockStatus: RXBlockStatus.ERROR });
                });
            } else {
                _this.setState({ blockStatus: RXBlockStatus.HIDE, buttonDisabled: false });
            }
        };

        _this.submit = function () {
            _this.form.submit();
        };

        _this.onSubmit = function (formData) {

            _this.setState({ blockStatus: RXBlockStatus.LOAD, buttonDisabled: true });
            new Promise(function (success, fail) {
                _this.props.onSubmit(formData, success, fail);
            }).then(function (data) {
                _this.setState({ blockStatus: RXBlockStatus.SUCCESS, buttonDisabled: false, show: false });
            }).catch(function (error) {
                console.log('in error: ' + error);
                _this.setState({ blockStatus: RXBlockStatus.HIDE, errorMessage: error, buttonDisabled: false });
            });
        };

        _this.onToggle = function () {
            console.log('in ontoggle');
            _this.setState({ show: false });
        };

        console.log('log props: ' + JSON.stringify(_this.props));

        var size = _this.props.size === undefined ? RXModalSize.NORMAL : _this.props.size;
        var waitLoad = _this.props.onLoad !== undefined;

        var initialValues = _this.props.initialValues === undefined ? {} : _this.props.initialValues;

        console.log('retrieve size with ' + size);
        console.log('waitload with ' + waitLoad);
        console.log('log props: ' + JSON.stringify(_this.props));
        _this.state = {
            buttonColor: RXModalColor.PRIMARY,
            buttonDisabled: true,
            size: size,
            waitLoad: waitLoad,
            show: false,
            blockStatus: RXBlockStatus.HIDE,
            blockColor: RXBlockColor.PRIMARY,
            blockMessage: "",
            initialValues: initialValues
        };
        _this.headerClass = css(_templateObject, _this.state.buttonColor);
        return _this;
    }

    RXModalForm.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.size != prevProps.size) {
            this.setState({ size: this.props.size });
        }

        if (this.props.initialValues != prevProps.initialValues) {
            console.log('try to change initialValues');
            this.setState({ initialValues: this.props.initialValues });
        }
    };

    RXModalForm.prototype.render = function render() {
        var _this2 = this;

        var _props$model = this.props.model,
            submit = _props$model.submit,
            formModel = _objectWithoutProperties(_props$model, ['submit']);

        console.log('log formModel: ' + JSON.stringify(this.props));

        return React.createElement(
            RXModal,
            {
                backdrop: this.props.backdrop,
                show: this.state.show,
                size: this.props.size,
                toggle: this.onToggle,
                title: this.props.title ? this.props.title : formModel.title,
                onLoad: this.onLoad,
                blockStatus: this.state.blockStatus,
                footer: React.createElement(
                    Button,
                    { block: submit.block, className: this.headerClass, color: this.state.buttonColor, disabled: this.state.buttonDisabled, size: 'lg', onClick: this.submit },
                    submit.title
                )
            },
            React.createElement(RXForm, { ref: function ref(_ref) {
                    _this2.form = _ref;
                }, transformers: this.props.transformers, events: this.props.events, model: formModel, onSubmit: this.onSubmit, validators: this.props.validators, placeholders: this.props.placeholders, initialValues: this.props.initialValues }),
            React.createElement(
                'div',
                { className: 'text-danger text-center font-weight-bold small text-uppercase' },
                this.state.errorMessage
            )
        );
    };

    return RXModalForm;
}(Component);

RXModalForm.defaultProps = {
    backdrop: true,
    events: {},
    title: null,
    transformers: {}
    // module.exports = {
    //     RXModalForm: RXModalForm
    // }

};